import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { Spinner } from "../components/UI";

const STATUS_LABEL = {
  entwurf: "Entwurf", in_pruefung: "In Prüfung", freigegeben: "Freigegeben",
  in_beratung: "In Beratung", beschlossen: "Beschlossen", abgelehnt: "Abgelehnt",
  zurueckgezogen: "Zurückgezogen",
};
// Wiederverwendung der bestehenden Badge-Farbklassen (siehe index.css) -
// kein neues Farbschema für Vorlagen-Status erfinden.
const STATUS_KLASSE = {
  entwurf: "geschlossen_beschlussunfaehig", in_pruefung: "eingeladen", freigegeben: "geplant",
  in_beratung: "eingeladen", beschlossen: "durchgefuehrt", abgelehnt: "abgesagt",
  zurueckgezogen: "abgesagt",
};

export default function Vorlagen() {
  const [vorlagen, setVorlagen] = useState(null);

  const laden = () => api.getVorlagen().then(setVorlagen);
  useEffect(() => { laden(); }, []);

  if (!vorlagen) return <Spinner />;

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700 }}>Vorlagen</h1>
        <Link to="/vorlagen/neu"><button className="btn btn-primary">+ Vorlage anlegen</button></Link>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr><th>Nummer</th><th>Titel</th><th>Typ</th><th>Status</th><th>Verfasser</th></tr>
          </thead>
          <tbody>
            {vorlagen.map(v => (
              <tr key={v.id}>
                <td>{v.vorlagennummer || "—"}</td>
                <td><Link to={`/vorlagen/${v.id}`}>{v.titel}</Link></td>
                <td>{v.typ}</td>
                <td><span className={`badge badge-${STATUS_KLASSE[v.status] || "abgesagt"}`}>{STATUS_LABEL[v.status] || v.status}</span></td>
                <td>{v.verfasser_name || v.verfasser_email || "—"}</td>
              </tr>
            ))}
            {vorlagen.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "#999", padding: 24 }}>Noch keine Vorlagen vorhanden.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
